import React, { useState, useRef, useEffect } from "react";
import { IconCaretDown, IconCaretUp } from "@arco-design/web-react/icon";
import "./ectype.less"; // 引入CSS样式
interface ICollapseProps {
  children?: any;
  isShow?: any;
  hiddenHeight?: number;
  width?: any;
}
const Ectype: React.FC<ICollapseProps> = (props) => {
  const { children, isShow, hiddenHeight = 102, width = "100%" } = props;
  const [isOpen, setIsOpen] = useState(false);
  const contentRef = useRef(null);
  const [height, setHeight] = useState(0);
  const toggleCollapse = () => {
    setIsOpen(!isOpen);
  };

  useEffect(() => {
    setHeight(isOpen ? contentRef.current.scrollHeight : hiddenHeight);
  }, [isOpen]);
  useEffect(() => {
    if (isOpen) {
      setIsOpen(false);
    }
  }, [isShow]);
  return (
    <div className="collapse-root-ectype" style={{ width }}>
      <div
        ref={contentRef}
        style={{ maxHeight: height }}
        className="collapse-content">
        {children}
      </div>
      <div
        className="collapse-btn"
        style={{ right: width == "100%" ? 50 : -15 }}>
        <div></div>
        {!isOpen ? (
          <div onClick={toggleCollapse}>
            展开
            <IconCaretDown />
          </div>
        ) : (
          <div onClick={toggleCollapse}>
            收起
            <IconCaretUp />
          </div>
        )}
        <div></div>
      </div>
    </div>
  );
};

export default Ectype;
